/**
 * Utility functions for JavaScript Object
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Yucho Ho
 */
import isArray from 'lodash/isArray'
import mergeWith from 'lodash/mergeWith'

/**
 * Perform lodash merge with the following custom behaviors:
 * 1. overwrites old array with new array
 * @param  {...Object} args The JavaScript Objects
 */
export const merge = (...args) => {
  return mergeWith(...args, (objValue, srcValue) => {
    if (isArray(objValue)) {
      return srcValue
    }
  })
}
